module.exports = __webpack_public_path__ + "img/profil-parfait.b03109bd.png";